import { render, staticRenderFns } from "./SideMenuSlides.vue?vue&type=template&id=601450f9&scoped=true&"
import script from "./SideMenuSlides.vue?vue&type=script&lang=js&"
export * from "./SideMenuSlides.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuSlides.vue?vue&type=style&index=0&id=601450f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601450f9",
  null
  
)

export default component.exports